import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { User } from '@edl-development/edl-common';
import { RubricResponse } from 'src/app/model/enum/rubric/rubric-response.enum';
import { RubricMasterDTO } from 'src/app/model/observation/rubric/rubric-master-dto.model';
import { RubricHelpers } from '../../observations/rubric/rubric-helpers/rubric.helpers';
import { DomainLookup } from 'src/app/model/interfaces/DomainLookup.interface';
import { SubdomainLookup } from 'src/app/model/interfaces/SubdomainLookup.interface';
import { DomainNavigationData } from 'src/app/model/interfaces/DomainNavigationData.interface';


@Injectable()
export class RubricFormBuilderService {

    constructor(private formBuilder: FormBuilder) { }

    public generateForm(rubricDomains: DomainLookup[] = [], observationDetails?: RubricMasterDTO, currentUser?: User | null, isReadOnly?: boolean) {
        return this.formBuilder.group({
            formDomains: this.generateAllDomainsGroup(rubricDomains, observationDetails, currentUser, isReadOnly)
        });
    }

    public generateAllDomainsGroup(domains: DomainLookup[], observationDetails?: RubricMasterDTO, currentUser?: User | null, isReadOnly?: boolean) {
        return this.formBuilder.group(domains.reduce((domainGroup: any, domain: DomainLookup) => (domainGroup[domain.Value] = this.generateDomainGroup(domain, observationDetails, currentUser, isReadOnly), domainGroup), {}));
    }

    public generateDomainGroup(domain: DomainLookup, observationDetails?: RubricMasterDTO, currentUser?: User | null, isReadOnly?: boolean) {
        return this.formBuilder.group(domain.Subdomains.reduce((componentGroup: any, component: SubdomainLookup) => (componentGroup[component.Value] = this.generateComponentGroup(domain, component, observationDetails, currentUser, isReadOnly), componentGroup), {}));
    }

    public generateComponentGroup(domain?: DomainLookup, component?: SubdomainLookup, observationDetails?: RubricMasterDTO, currentUser?: User | null, isReadOnly?: boolean) {
        const teacherRubricResponse = RubricHelpers.getRubricResponeForComponent_TargetUser(observationDetails, domain?.Value, component?.Value);
        const evaluatorRubricResponse = RubricHelpers.getRubricResponeForComponent_EvaluatingUser(observationDetails, domain?.Value, component?.Value);


        return this.formBuilder.group({
            teacherResponse: [{ value: teacherRubricResponse?.response ??  RubricResponse.UNSELECTED, disabled: isReadOnly || observationDetails?.targetUser?.userID !== currentUser?.UserID}, []],
            principalResponse: [{ value: evaluatorRubricResponse?.response ?? RubricResponse.UNSELECTED, disabled: isReadOnly || observationDetails?.evaluatingUser?.userID !== currentUser?.UserID }, []]
        });
    }

    public generateDomainNavigationData(form: FormGroup, showTargetUser: boolean): DomainNavigationData {
        const formDomains = form?.getRawValue()['formDomains'];

        return Object.keys(formDomains).reduce((domains: any, domain: string) => {
            const formComponents = formDomains[domain];
            domains[domain] = Object.keys(formComponents).reduce((components: any, component: string) => {
                const formResponses = formComponents[component];
                components[component] = {
                    teacherResponse: showTargetUser ? formResponses.teacherResponse : RubricResponse.UNSELECTED,
                    principalResponse: formResponses.principalResponse
                }
                return components;
            }, {})
            return domains;
        }, {})

    }
}
